/**
 * Configuración para entornos de prueba y desarrollo
 */

/**
 * IDs de empresas que NO requieren validación de QR
 * Estas empresas tienen datos ficticios para pruebas
 */
export const TEST_EMPRESA_IDS = [
  5, // Darpha Fire Solutions (empresa de pruebas)
];

/**
 * Verifica si una empresa está configurada como empresa de prueba
 * @param {number} idempresacliente - ID de la empresa cliente
 * @returns {boolean} - True si es empresa de prueba
 */
export const isTestEmpresa = (idempresacliente) => {
  return TEST_EMPRESA_IDS.includes(parseInt(idempresacliente));
};

/**
 * Configuración de características por tipo de empresa
 */
export const EMPRESA_FEATURES = {
  /**
   * Si es true, NO se requiere escanear QR para completar reportes
   */
  skipQRValidation: (idempresacliente) => isTestEmpresa(idempresacliente),
  
  /**
   * Si es true, se muestran mensajes de "Modo Prueba" en la UI
   */
  showTestMode: (idempresacliente) => isTestEmpresa(idempresacliente),
};

const testConfig = {
  TEST_EMPRESA_IDS,
  isTestEmpresa,
  EMPRESA_FEATURES,
};

export default testConfig;
